// assets/free-shipping-bar.js
(function () {
  let el = null;
  let msgEl = null;
  let fillEl = null;
  let barEl = null;

  let thresholdCents = 0;
  let alwaysFreeMode = false;
  let fixedShippingEnabled = false;
  let fixedShippingRules = [];

  let fallbackInterval = null;
  let totalsObserver = null;
  let drawerObserver = null;
  let bodyObserver = null;

  function moneyBRL(cents) {
    const value = (cents || 0) / 100;
    try {
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (_error) {
      return `R$ ${value.toFixed(2).replace('.', ',')}`;
    }
  }

  function parseBool(value) {
    const normalized = String(value || '').toLowerCase().trim();
    return normalized === 'true' || normalized === '1';
  }

  function parseMoneyToCents(value) {
    const num = Number(value || 0);
    if (Number.isNaN(num)) return 0;
    return Math.max(0, Math.round(num * 100));
  }

  function parseFixedShippingRules(raw) {
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];

      return parsed
        .map((rule) => ({
          enabled: rule.enabled !== false,
          min: parseMoneyToCents(rule.min || 0),
          max: parseMoneyToCents(rule.max || 0),
          price: parseMoneyToCents(rule.price || 0)
        }))
        .filter((rule) => rule.enabled)
        .sort((a, b) => a.min - b.min);
    } catch (_error) {
      return [];
    }
  }

  function bind() {
    el = document.getElementById('FreeShippingBar');
    if (!el) return false;

    msgEl = el.querySelector('.fsb__msg');
    fillEl = el.querySelector('.fsb__bar__fill');
    barEl = el.querySelector('.fsb__bar');

    const thresholdReais = parseFloat(el.dataset.threshold || '0') || 0;
    thresholdCents = parseMoneyToCents(thresholdReais);

    alwaysFreeMode = parseBool(el.dataset.alwaysFree);
    fixedShippingEnabled = parseBool(el.dataset.fixedShippingEnabled);
    fixedShippingRules = parseFixedShippingRules(el.dataset.fixedShippingRules);

    return !!(msgEl && fillEl && barEl);
  }

  function isWholesale() {
    if (!el) return false;
    return String(el.dataset.isSpecial || 'false') === 'true';
  }

  function getText(keyBase) {
    const wholesale = isWholesale();

    if (wholesale) {
      const wholesaleKey = `${keyBase}Atacado`;
      const wholesaleValue = el?.dataset?.[wholesaleKey];
      if (wholesaleValue != null && String(wholesaleValue).trim() !== '') {
        return wholesaleValue;
      }
    }

    const baseValue = el?.dataset?.[keyBase];
    if (baseValue != null && String(baseValue).trim() !== '') {
      return baseValue;
    }

    if (keyBase === 'textSuccess') return '🎉 Parabéns! Você ganhou frete grátis.';
    if (keyBase === 'textPrefix') return 'Faltam';
    if (keyBase === 'textSuffix') return 'para ganhar frete grátis';

    if (keyBase === 'fixedShippingMissingPrefix') return 'Faltam';
    if (keyBase === 'fixedShippingMissingSuffix') return 'para liberar o frete fixo de';
    if (keyBase === 'fixedShippingActivePrefix') return 'Parabéns, você ganhou frete fixo de';
    if (keyBase === 'fixedShippingActiveSuffix') return '';

    return '';
  }

  function setBarProgress(pct) {
    const safePct = Math.max(0, Math.min(100, Math.round(pct || 0)));
    barEl.setAttribute('aria-valuenow', String(safePct));
    fillEl.style.inset = `0 ${100 - safePct}% 0 0`;
  }

  function setCompleteState() {
    el.classList.add('fsb--complete');
  }

  function setIncompleteState() {
    el.classList.remove('fsb--complete');
  }

  function showBar() {
    el.hidden = false;
  }

  function hideBar() {
    el.hidden = true;
  }

  function findCurrentFixedRule(totalCents) {
    if (!fixedShippingRules.length) return null;

    for (const rule of fixedShippingRules) {
      const minOk = totalCents >= rule.min;
      const maxOk = rule.max <= 0 ? true : totalCents <= rule.max;
      if (minOk && maxOk) return rule;
    }

    return null;
  }

  function findNextFixedRule(totalCents) {
    if (!fixedShippingRules.length) return null;

    for (const rule of fixedShippingRules) {
      if (totalCents < rule.min) return rule;
    }

    return null;
  }

  function renderFixedShipping(totalCents) {
    const currentRule = findCurrentFixedRule(totalCents);

    if (currentRule) {
      if (currentRule.price <= 0) {
        msgEl.textContent = getText('textSuccess');
        setBarProgress(100);
        setCompleteState();
        showBar();
        return true;
      }

      const missingToFree = Math.max(0, thresholdCents - totalCents);
      const progressBase = thresholdCents > 0 ? thresholdCents : (currentRule.max > 0 ? currentRule.max : totalCents);
      const pct = progressBase > 0 ? Math.min(100, (totalCents / progressBase) * 100) : 100;

      if (thresholdCents > 0 && totalCents < thresholdCents) {
        msgEl.innerHTML =
          `${getText('fixedShippingActivePrefix')} <strong class="fsb__price">${moneyBRL(currentRule.price)}</strong>. ` +
          `Faltam apenas <strong class="fsb__price">${moneyBRL(missingToFree)}</strong> para receber frete grátis`;
        setBarProgress(pct);
        setIncompleteState();
        showBar();
        return true;
      }

      msgEl.textContent = getText('textSuccess');
      setBarProgress(100);
      setCompleteState();
      showBar();
      return true;
    }

    const nextRule = findNextFixedRule(totalCents);

    if (nextRule) {
      const missing = Math.max(0, nextRule.min - totalCents);
      const pct = nextRule.min > 0 ? Math.min(100, (totalCents / nextRule.min) * 100) : 0;

      msgEl.innerHTML =
        `Faltam apenas <strong class="fsb__price">${moneyBRL(missing)}</strong> para receber frete fixo de ` +
        `<strong class="fsb__price">${moneyBRL(nextRule.price)}</strong>`;
      setBarProgress(pct);
      setIncompleteState();
      showBar();
      return true;
    }

    return false;
  }

  function setProgress(totalCents) {
    if (!el || !msgEl || !fillEl || !barEl) return;

    const hasItems = totalCents > 0;
    const wholesale = isWholesale();

    if (alwaysFreeMode) {
      showBar();
      setBarProgress(100);
      msgEl.textContent = getText('textSuccess');
      setCompleteState();
      return;
    }

    if (!hasItems) {
      hideBar();
      return;
    }

    if (wholesale && fixedShippingEnabled && fixedShippingRules.length > 0) {
      const handledByFixedShipping = renderFixedShipping(totalCents);
      if (handledByFixedShipping) return;
    }

    if (thresholdCents <= 0) {
      showBar();
      setBarProgress(100);
      msgEl.textContent = getText('textSuccess');
      setCompleteState();
      return;
    }

    showBar();

    const ratio = Math.min(1, totalCents / thresholdCents);
    const pct = Math.round(ratio * 100);
    setBarProgress(pct);

    if (totalCents >= thresholdCents) {
      msgEl.textContent = getText('textSuccess');
      setCompleteState();
    } else {
      const falta = thresholdCents - totalCents;
      const prefix = getText('textPrefix');
      const suffix = getText('textSuffix');

      msgEl.innerHTML = `${prefix} <strong class="fsb__price">${moneyBRL(falta)}</strong> ${suffix}`;
      setIncompleteState();
    }
  }

  async function fetchCartAndRender() {
    if (!el && !bind()) return;
    if (!el) return;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      setProgress(cart.total_price || 0);
    } catch (_error) {}
  }

  function disconnectObservers() {
    if (totalsObserver) {
      totalsObserver.disconnect();
      totalsObserver = null;
    }

    if (drawerObserver) {
      drawerObserver.disconnect();
      drawerObserver = null;
    }

    if (bodyObserver) {
      bodyObserver.disconnect();
      bodyObserver = null;
    }
  }

  function setupTotalsObserver() {
    if (!('MutationObserver' in window)) return;

    if (totalsObserver) {
      totalsObserver.disconnect();
      totalsObserver = null;
    }

    const totalsNode =
      document.querySelector('[data-cart-total]') ||
      document.querySelector('.cart-drawer .totals__total-value');

    if (!totalsNode) return;

    totalsObserver = new MutationObserver(() => {
      fetchCartAndRender();
    });

    totalsObserver.observe(totalsNode, {
      characterData: true,
      subtree: true,
      childList: true,
      attributes: true
    });
  }

  function setupDrawerObserver() {
    if (!('MutationObserver' in window)) return;

    if (drawerObserver) {
      drawerObserver.disconnect();
      drawerObserver = null;
    }

    const drawerRoot =
      document.getElementById('CartDrawer') ||
      document.getElementById('cart-drawer-root') ||
      document.body;

    if (!drawerRoot) return;

    drawerObserver = new MutationObserver(() => {
      const currentEl = document.getElementById('FreeShippingBar');
      if (currentEl && currentEl !== el) {
        if (bind()) {
          setupTotalsObserver();
          fetchCartAndRender();
        }
      }
    });

    drawerObserver.observe(drawerRoot, { childList: true, subtree: true });
  }

  function setupBodyObserver() {
    if (!('MutationObserver' in window)) return;

    if (bodyObserver) {
      bodyObserver.disconnect();
      bodyObserver = null;
    }

    bodyObserver = new MutationObserver(() => {
      const currentEl = document.getElementById('FreeShippingBar');
      if (currentEl && (!el || currentEl !== el || !el.isConnected)) {
        if (bind()) {
          setupTotalsObserver();
          fetchCartAndRender();
        }
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function patchNetworkWatchers() {
    try {
      if (window._fsbPatched) return;

      const nativeFetch = window.fetch;
      window.fetch = async function (input, init) {
        const url = typeof input === 'string' ? input : (input?.url || '');
        const method = (init?.method || '').toUpperCase();

        const isCartChange =
          method === 'POST' &&
          (
            /\/cart\/add(\.js)?(\?|$)/.test(url) ||
            /\/cart\/change(\.js)?(\?|$)/.test(url) ||
            /\/cart\/update(\.js)?(\?|$)/.test(url) ||
            /\/cart\/clear(\.js)?(\?|$)/.test(url)
          );

        const resp = await nativeFetch.apply(this, arguments);

        if (isCartChange && resp && resp.ok) {
          setTimeout(fetchCartAndRender, 150);
        }

        return resp;
      };

      const nativeOpen = XMLHttpRequest.prototype.open;
      const nativeSend = XMLHttpRequest.prototype.send;
      const requestMap = new WeakMap();

      XMLHttpRequest.prototype.open = function (method, url) {
        requestMap.set(this, {
          method: (method || '').toUpperCase(),
          url: String(url || '')
        });
        return nativeOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        const meta = requestMap.get(this) || {};

        const isCartChange =
          meta.method === 'POST' &&
          (
            /\/cart\/add(\.js)?(\?|$)/.test(meta.url) ||
            /\/cart\/change(\.js)?(\?|$)/.test(meta.url) ||
            /\/cart\/update(\.js)?(\?|$)/.test(meta.url) ||
            /\/cart\/clear(\.js)?(\?|$)/.test(meta.url)
          );

        if (isCartChange) {
          this.addEventListener('load', () => {
            if (this.status >= 200 && this.status < 300) {
              setTimeout(fetchCartAndRender, 150);
            }
          });
        }

        return nativeSend.apply(this, arguments);
      };

      window._fsbPatched = true;
    } catch (_error) {}
  }

  function init() {
    if (!bind()) return;

    disconnectObservers();
    setupTotalsObserver();
    setupDrawerObserver();
    setupBodyObserver();
    patchNetworkWatchers();

    fetchCartAndRender();

    const refresh = () => {
      setTimeout(() => {
        if (bind()) {
          setupTotalsObserver();
          fetchCartAndRender();
        }
      }, 50);
    };

    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:change', refresh);
    document.addEventListener('cart-drawer:updated', refresh);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', refresh);
    document.addEventListener('cart:discount-applied', refresh);
    document.addEventListener('cart:discount-removed', refresh);

    document.addEventListener('cart:updated', (event) => {
      if (
        event.detail &&
        (
          event.detail.source === 'discount-removal' ||
          event.detail.source === 'discount-section-update' ||
          event.detail.source === 'cart-display-update'
        )
      ) {
        setTimeout(() => {
          if (bind()) {
            setupTotalsObserver();
            fetchCartAndRender();
          }
        }, 200);
      }
    });

    document.addEventListener('section:morphed', (event) => {
      if (
        event.detail &&
        (
          event.detail.sectionId === 'cart-drawer' ||
          event.detail.sectionId === 'cart-drawer-root'
        )
      ) {
        const tryReinit = (attempt = 1, maxAttempts = 6) => {
          setTimeout(() => {
            if (bind()) {
              setupTotalsObserver();
              fetchCartAndRender();
            } else if (attempt < maxAttempts) {
              tryReinit(attempt + 1, maxAttempts);
            }
          }, attempt * 120);
        };

        tryReinit();
      }
    });

    document.addEventListener('mouseup', (e) => {
      const trigger = e.target.closest(
        '.quantity__button, .cart-remove-button, [data-qty-minus], [data-qty-plus], [data-cart-item-remove], [name="checkout"]'
      );

      if (trigger) {
        setTimeout(fetchCartAndRender, 250);
      }
    });

    if (fallbackInterval) {
      clearInterval(fallbackInterval);
      fallbackInterval = null;
    }

    fallbackInterval = setInterval(() => {
      if (!el || !el.isConnected) {
        if (!bind()) return;
        setupTotalsObserver();
      }

      if (el && el.hidden) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then((res) => res.json())
          .then((cart) => {
            if ((cart?.total_price || 0) > 0) {
              showBar();
              setProgress(cart.total_price || 0);
            }
          })
          .catch(() => {});
      }
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();